// extracted by mini-css-extract-plugin
export default {"formField":"Pra-z","error":"Qra-z","disabled":"Rra-z","fieldError":"Sra-z","errorText":"Tra-z","button":"Ura-z","acknowledgment":"Vra-z"};